import React, { useState, useEffect } from "react";
import { PDFViewer } from "@react-pdf/renderer";
import PageTitle from "../components/PageTitle/PageTitle";
import ProfileService from "../services/profile.service";
import GroomNewDesignPdf from "./GroomNewDesignPdf";

function chunk(array, count) {
    if (count == null || count < 1) return [];
    var result = [];
    var i = 0, length = array.length;
    while (i < length) {
      result.push(Array.prototype.slice.call(array, i, i += count));
    }
    return result;
  };

const GroomNewDesign = () => {
    const [userList, setUserList] = useState([]);
    const [dataLength, setDataLength] = useState(0);

  useEffect(() => {
    ProfileService.getGrooms()
      .then((response) => {
        setDataLength(response.data.data.length);
        setUserList(chunk(response.data.data, 8));
      })
      .catch((error) => {
        // console.log(error.message);
      });
  }, []);

  return (
    <>
    <PageTitle title="उपवर माहिती" />
      <section className="vh_dashboard p-0">
        <PDFViewer>
          <GroomNewDesignPdf data={userList} length={dataLength} />
        </PDFViewer>
      </section>
    </>
  );
};

export default GroomNewDesign;
